import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import en from "./locales/en.json";
import nl from "./locales/nl.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      nl: { translation: nl },
    },
    fallbackLng: "fr",
    lng: (typeof window !== "undefined" && window.localStorage.getItem("myanimation.lang")) || "fr",
    supportedLngs: ["fr", "en", "nl"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "myanimation.lang",
    },
    returnEmptyString: false,
  });

// Reflect current language in <html lang="..."> for SEO
if (typeof document !== "undefined") {
  const setLang = (lng) => {
    document.documentElement.lang = (lng || "fr").split("-")[0];
  };
  setLang(i18n.language);
  i18n.on("languageChanged", setLang);
}

export default i18n;
